import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/sales-invoice-returns/`;
const pathById = `${pathBase}:salesInvoiceReturnId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const salesInvoiceReturns = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
};
